import { getRootWindow } from './window';

type EventListenerCallback<DataType = unknown> = (
  event:
    | CustomEvent<DataType>
    | MessageEvent<{ type: string; payload: DataType }>,
) => void;

export function subscribe<DataType = unknown>(
  eventName: string,
  onEvent: (data: DataType) => void,
) {
  const callback: EventListenerCallback<DataType> = (event) => {
    if (event instanceof MessageEvent) {
      if (
        event.origin !== getRootWindow().location.origin ||
        event.data?.type !== eventName
      ) {
        return;
      }
      onEvent(event.data?.payload);
    } else {
      onEvent(event.detail);
    }
  };
  getRootWindow().addEventListener(eventName, callback as EventListener);
  return {
    unsubscribe() {
      unsubscribe<DataType>(eventName, callback);
    },
  };
}

export function unsubscribe<DataType = any>(
  eventName: string,
  onEvent: EventListenerCallback<DataType>,
) {
  getRootWindow().removeEventListener(eventName, onEvent as EventListener);
}
